import {DrawerWrapper} from '@wandb/weave/common/components/DrawerWrapper';
import React, {useMemo} from 'react';

import {SUPPORTED_MEDIA_DRAWER_TYPES} from '../../PanelMediaBrowser/supportedMediaDrawerTypes';
import {useWorkspaceDrawerContext} from '../WorkspaceDrawerContextProvider';
import {
  SECTION_LINE_PLOT_SETTINGS_DESCRIPTION,
  SECTION_MEDIA_SETTINGS_DESCRIPTION,
} from './constants';
import {useSectionMediaCardTypes} from './hooks';
import {SettingsMenuItem} from './SettingsMenuItem';

export enum SelectedSectionSettingType {
  LinePlot = 'line-plot',
  Media = 'media',
}

export const SectionSettingsMenu = ({
  setSelectedSettingType,
}: {
  setSelectedSettingType: (type: SelectedSectionSettingType) => void;
}) => {
  const {closeWorkspaceDrawer} = useWorkspaceDrawerContext();
  const mediaCardTypes = useSectionMediaCardTypes();
  const hasSupportedMediaCardType = useMemo(
    () =>
      mediaCardTypes.some(mediaCardType =>
        SUPPORTED_MEDIA_DRAWER_TYPES.includes(mediaCardType)
      ),
    [mediaCardTypes]
  );
  return (
    <DrawerWrapper title="Section settings" onClose={closeWorkspaceDrawer}>
      <SettingsMenuItem
        dataTest="section-settings-line-plot-menu-item"
        icon="line-plot-alt2"
        color="blue"
        title="Line plots"
        description={SECTION_LINE_PLOT_SETTINGS_DESCRIPTION}
        onClick={() =>
          setSelectedSettingType(SelectedSectionSettingType.LinePlot)
        }
      />
      {hasSupportedMediaCardType && (
        <SettingsMenuItem
          dataTest="section-settings-media-menu-item"
          icon="photo"
          color="purple"
          title="Media"
          description={SECTION_MEDIA_SETTINGS_DESCRIPTION}
          onClick={() =>
            setSelectedSettingType(SelectedSectionSettingType.Media)
          }
        />
      )}
    </DrawerWrapper>
  );
};
